import { Menu } from 'antd';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { menuItems } from '@/constants/menu-items.config';
import { Auth, hasPermission } from '@/shared/security/hasPermission';
import { withSecurity } from '@/shared/security/withSecurity';

const findMatchedKey = (pathname: string, menuItems: any[]): string | undefined => {
  const keys = menuItems
    .flatMap((item) => {
      if (!item) return [];
      if ('children' in item && item.children?.length) {
        return [item.key, ...item.children.map((child: any) => child?.key)].filter(
          Boolean,
        ) as string[];
      }
      return item.key ? [item.key as string] : [];
    })
    .filter(Boolean) as string[];

  const normalizedKey = pathname.replace(/\/+$/, '') || '/';

  return keys
    .filter((key) =>
      key === '/' ? normalizedKey === '/' : normalizedKey.startsWith(key),
    )
    .sort((a, b) => b.length - a.length)[0]; // выбираем самый длинный префикс
};

interface AppMenuProps {
  auth: Auth;
}
export const AppMenu = withSecurity(({ auth }: AppMenuProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedKey = useMemo(
    () => findMatchedKey(location.pathname, menuItems) ?? '',
    [location.pathname],
  );

  const securityItems = useMemo(() => {
    return menuItems.filter((item) => hasPermission(auth, item.security));
  }, [auth]);

  const onClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  return (
    <Menu
      mode="inline"
      items={securityItems}
      theme={'light'}
      selectedKeys={selectedKey ? [selectedKey] : []}
      onClick={onClick}
    />
  );
});
